import React, { RefObject, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { getProfile } from "../../../api/consultants-api";
import { consultant } from "../../../model";
import { getMonthlyInvoice, getMonthlyItemizedInvoice, getWeeklyInvoice } from "../../../api/finance-api";
import moment from "moment";
import { nanoid } from "nanoid";
import Moment from "react-moment";
import Currency from "react-currency-formatter";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Skeleton from "react-loading-skeleton";
import { fi } from "date-fns/locale";
import { getEffortsDetails } from "./efforts";

// Returns an array of holiday dates (moment objects) for the given year
function getUSHolidays(year: number): moment.Moment[] {
    return [
        moment(`${year}-01-01`), // New Year's Day
        moment(`${year}-01-20`), // Martin Luther King Jr. Day (fixed for 2025, otherwise calculate 3rd Monday of Jan)
        moment(`${year}-02-17`), // Presidents Day (fixed for 2025, otherwise calculate 3rd Monday of Feb)
        moment(`${year}-05-26`), // Memorial Day (fixed for 2025, otherwise last Monday of May)
        moment(`${year}-06-19`), // Juneteenth National Independence Day
        moment(`${year}-07-04`), // Independence Day
        moment(`${year}-09-01`), // Labor Day (fixed for 2025, otherwise 1st Monday of Sep)
        moment(`${year}-10-13`), // Columbus Day (fixed for 2025, otherwise 2nd Monday of Oct)
        moment(`${year}-11-11`), // Veterans Day
        moment(`${year}-11-27`), // Thanksgiving Day (fixed for 2025, otherwise 4th Thursday of Nov)
        moment(`${year}-12-25`), // Christmas Day
    ];
}

// Utility function to calculate working days for each month of a given year, excluding holidays
function getWorkingDaysPerMonth(year: number): number[] {
    // console.log("Calculating working days for year:", year);
    const holidays = getUSHolidays(year).map((d) => d.format("YYYY-MM-DD"));
    // console.log("Holidays for year", year, holidays);
    const workingDays: number[] = [];
    for (let month = 0; month < 12; month++) {
        let count = 0;
        const daysInMonth = moment([year, month]).daysInMonth();
        for (let day = 1; day <= daysInMonth; day++) {
            const date = moment([year, month, day]);
            const dayOfWeek = date.day(); // 0 = Sunday, 6 = Saturday
            const dateStr = date.format("YYYY-MM-DD");
            if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays.includes(dateStr)) {
                count++;
            }
        }
        workingDays.push(count);
    }
    return workingDays;
}

export default function Invoice() {
    const { uuid, _m, _y, _w, _type, _invNo, _d } = useParams();
    console.log(useParams());

    const [consultant, setConsultant] = useState<any>();
    const [items, setItems] = useState<any>();

    const [metadata, setMetadata] = useState<any>();

    //document.getElementById("invoiceCard")
    const reportTemplateRef = useRef() as RefObject<HTMLDivElement>;

    useEffect(() => {
        // setElementOutlet(reportTemplateRef.current);

        // Load Consultant Profile using UUID
        getProfile(uuid).then((r) => {
            r[0].fixed_payroll = Number(r[0].fixed_payroll) || 0; // Ensure fixed_payroll is a number
            console.log(r);
            setConsultant(r[0]);

            setTimeout(() => {
                if (r[0]?.billing_period === "Monthly") {
                    generateMonthlyInvoice(r[0]);
                } else if (r[0]?.billing_period === "Monthly Itemized") {
                    generateMonthlyItemizedInvoice();
                } else if (r[0]?.billing_period === "Weekly") {
                    generateWeeklyInvoice();
                } else {
                    generateMonthlyInvoice(r[0]);
                }
            }, 500);
        });
    }, []);

    function generateMonthlyInvoice(consultant): any {
        console.log(_y);
        console.log(_m);
        console.log(consultant);

        getMonthlyInvoice({
            uuid: uuid,
            checkDate: moment()
                .set("year", Number(_y))
                .set("month", Number(_m) - 1)
                .toDate(),
        }).then(async (r) => {
            console.log(r);
            setItems(r);

            if (r && r.length > 0) {
                console.warn(consultant?.fixed_payroll);
                // Get fixed_payroll from consultant

                const fixed_payment = Number(r[0]?.fixed_payment || r[1]?.fixed_payment || 0);

                const fixedPayroll = Number(consultant?.fixed_payroll) || 0;
                console.log(fixedPayroll);

                // Get the invoice date from r[0] or r[1]
                const invoiceDate = r[0]?._d || r[1]?._d;
                // Calculate working days for the invoice month
                let workingDays = invoiceDate ? getWorkingDaysPerMonth(moment(invoiceDate).year())[moment(invoiceDate).month() - 1] : 0;

                console.log("Working Days: ", workingDays);

                // if (fixedPayroll) {
                //     try {
                //         const effortsDetails = await getEffortsDetails({
                //             _d: moment(invoiceDate).set("year", Number(_y)).set("month", Number(_m) - 1),
                //             uuid: uuid
                //         });
                //         console.error(effortsDetails);

                //         if (effortsDetails) {
                //             // && effortsDetails.length > 0 // FIXME
                //             // console.log("Efforts details for row:", row, "is", effortsDetails);
                //             // Any logic that depends on effortsDetails should go here
                //             // For example:
                //             // row.effortsDetails = effortsDetails;

                //             workingDays = effortsDetails && effortsDetails[0]?.working_days; // Use fetched working days or fallback to calculated
                //         }

                //         // console.log(row);
                //     } catch (error) {
                //         console.error("Error fetching efforts details:", error);
                //     }
                // }

                // Get punched days
                const punchedDays = r[0]?._punched || r[1]?._punched || 0;
                // Calculate _sbill using the formula
                const _sbill: number =
                    r &&
                    r
                        .map((a) => a._sbill)
                        .reduce(function (a, b) {
                            return a + b;
                        }, 0);

                let _shrs: number =
                    r &&
                    r
                        .map((a) => a._shrs)
                        .reduce(function (a, b) {
                            return a + b;
                        }, 0);

                let _spayment: number =
                    r &&
                    r
                        .map((a) => a._spayment)
                        .reduce(function (a, b) {
                            return a + b;
                        }, 0);

                if (r[0]) {
                    setMetadata({
                        ...metadata,
                        invoiceNo: r[0]?.invoice_no,
                        invoiceDate: r[0]?._ts_invoice || r[1]?._ts_invoice,
                        invoiceDateLabel: r[0]?._ts_invoice_label || r[1]?._ts_invoice_label,
                        invoiceDueDate: r[0]?._ts_invoice_due,
                        title: moment.utc(r[0]?._d).format("MMMM YYYY"),
                        _punched: punchedDays,
                        _spayment: _spayment,
                        _sbill: _sbill,
                        _shrs: _shrs,
                    });
                } else if (r.length > 2 && r[1]) {
                    setMetadata({
                        ...metadata,
                        invoiceNo: r[1]?.invoice_no,
                        invoiceDate: r[1]?._ts_invoice,
                        invoiceDateLabel: r[0]?._ts_invoice_label || r[1]?._ts_invoice_label,
                        invoiceDueDate: r[1]?._ts_invoice_due,
                        title: moment.utc(r[1]?._d).format("MMMM YYYY"),
                        _punched: punchedDays,
                        _spayment: _spayment,
                        _sbill: _sbill,
                        _shrs: _shrs,
                    });
                } else {
                    console.error(r);
                }

                console.log(r[0]);
            }

            console.log(metadata);
        });
    }

    function generateWeeklyInvoice(): any {
        console.log(_y);
        console.log(_m);

        getWeeklyInvoice({
            uuid: uuid,
            checkDate: moment()
                .set("year", Number(_y))
                .set("month", Number(_m) - 1)
                .toDate(),
            week: Number(_w) - 1,
        }).then((r) => {
            console.log(r);
            setItems(r);

            if (r && r.length > 0) {
                let _sbill: number = r
                    .map((a) => a._sbill)
                    .reduce(function (a, b) {
                        return a + b;
                    });

                let _shrs: number = r
                    .map((a) => a._shrs)
                    .reduce(function (a, b) {
                        return a + b;
                    });

                let _spayment: number = r
                    .map((a) => a._spayment)
                    .reduce(function (a, b) {
                        return a + b;
                    });

                console.log(r[0]);
                setMetadata({ ...metadata, _punched: r[0]?._punched || r[1]?._punched || 0, invoiceNo: r[0]?.invoice_no, invoiceDate: r[0]?._ts_invoice || r[1]?._ts_invoice || r[2]?._ts_invoice || r[3]?._ts_invoice || r[4]?._ts_invoice, invoiceDateLabel: r[0]?._ts_invoice_label || r[1]?._ts_invoice_label || r[2]?._ts_invoice_label || r[3]?._ts_invoice_label || r[4]?._ts_invoice_label, invoiceDueDate: r[0]?._ts_invoice_due, title: "", _spayment: _spayment, _sbill: _sbill, _shrs: _shrs });
                console.log(metadata);
            }
        });
    }

    function generateMonthlyItemizedInvoice(): any {
        console.log(_y);
        console.log(_m);

        getMonthlyItemizedInvoice({
            uuid: uuid,
            checkDate: moment()
                .set("year", Number(_y))
                .set("month", Number(_m) - 1)
                .toDate(),
        }).then((r) => {
            console.log(r);
            setItems(r);

            // // Generate all dates for the month
            // const year = Number(_y);
            // const month = Number(_m) - 1;
            // const daysInMonth = moment([year, month]).daysInMonth();
            // const allDates = Array.from({ length: daysInMonth }, (_, i) =>
            //     moment([year, month, i + 1]).format("YYYY-MM-DD")
            // );

            // // Patch missing dates
            // const baseRate = consultant?.rate || 0; // or set your default rate here
            // const patched = allDates.map(date => {
            //     const found = r.find(item => moment(item.first_day_of_week).isSame(date, 'day'));
            //     if (found) return found;
            //     return {
            //         first_day_of_week: date,
            //         last_day_of_week: date,
            //         _shrs: 0,
            //         rate: baseRate,
            //         _sbill: 0,
            //         // ...add other fields as needed
            //     };
            // });

            // setItems(patched);

            if (r && r.length > 0) {
                let _sbill: number = r
                    .map((a) => a._sbill)
                    .reduce(function (a, b) {
                        return a + b;
                    })
                    .toFixed(2);

                let vmo = r[0]?.vmo || r[1]?.vmo || r[2]?.vmo || r[3]?.vmo || r[4]?.vmo || 0;
                let insurance_fee = r;

                let _shrs: number = r
                    .map((a) => a._shrs)
                    .reduce(function (a, b) {
                        return a + b;
                    });

                let _spayment: number = r
                    .map((a) => a._spayment)
                    .reduce(function (a, b) {
                        return a + b;
                    });

                console.log(
                    "Rates from backend:",
                    r.map((a) => a.rate)
                );

                console.log(r.find((a) => a.rate));

                const firstNonZeroRate = r.find((a) => a.rate > 0)?.rate || 0;
                console.log("firstNonZeroRate - ", firstNonZeroRate);

                const maxNonZeroRate = Math.max(...r.map((a) => a.rate).filter((rate) => rate > 0), 0);
                console.log("maxNonZeroRate - ", maxNonZeroRate);

                console.log(r);
                setMetadata({
                    ...metadata,
                    vmo: r[0]?.vmo || r[1]?.vmo || r[2]?.vmo || r[3]?.vmo || r[4]?.vmo || 0,
                    insurance_fee: r[0]?.insurance_fee || r[1]?.insurance_fee || r[2]?.insurance_fee || r[3]?.insurance_fee || r[4]?.insurance_fee || 0,
                    _punched: r[0]?._punched || r[1]?._punched || r[2]?._punched || r[3]?._punched || r[4]?._punched || 0,
                    invoiceNo: r[0]?.invoice_no || r[1]?.invoice_no || r[2]?.invoice_no || r[3]?.invoice_no || r[4]?.invoice_no || "-",
                    invoiceDate: r[0]?._ts_invoice || r[1]?._ts_invoice || r[2]?._ts_invoice || r[3]?._ts_invoice || r[4]?._ts_invoice || "-",
                    invoiceDateLabel: r[0]?._ts_invoice_label || r[1]?._ts_invoice_label || r[2]?._ts_invoice_label || r[3]?._ts_invoice_label || r[4]?._ts_invoice_label || "-",
                    invoiceDueDate: r[0]?._ts_invoice_due,
                    title: "",
                    _spayment: _spayment,
                    _sbill: Number(_sbill).toFixed(2),
                    // _deductions: (Number(_sbill) * (vmo + insurance_fee)) / 100 || 0,
                    // _net: (Number(_sbill) - Number(_sbill) * (vmo + insurance_fee)) / 100,
                    _shrs: _shrs,
                    firstNonZeroRate: firstNonZeroRate,
                    maxNonZeroRate: maxNonZeroRate,
                });

                console.log(metadata);
            }
        });
    }

    const onGeneratePDF = () => {
        console.log("onGeneratePDF");
        const input = document.getElementById("invoiceCard")!;
        const divHeight = input?.clientHeight;
        const divWidth = input?.clientWidth;
        const ratio = divHeight / divWidth;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.8); // Compress the image
            const pdf = new jsPDF({
                orientation: "landscape",
            });

            const imgProps = pdf.getImageProperties(imgData);
            const Width = pdf.internal.pageSize.getWidth();
            let Height = (imgProps.height * Width) / imgProps.width;
            Height = ratio * Width;

            pdf.addImage(imgData, "JPEG", 50, 0, Width - 100, Math.min(Height - 100, pdf.internal.pageSize.getHeight()));
            pdf.save(`Invoice - ${consultant?.name} - ${moment.utc(_d).format("MMMM YYYY")}.pdf`);
        });
    };

    const toUTCFormat = (d: any) => {
        // console.log(d);
        return moment.utc(d).format("MMMM DD, YYYY"); //MM/DD/YYYY
        // return moment(d).add(1, "day").format();
    };

    const toUTCFormat1 = (d: any) => {
        // console.log(d);
        return moment.utc(d).format("MMMM DD"); //MM/DD/YYYY
        // return moment(d).add(1, "day").format();
    };

    return (
        <>
            <main className="bg-gray-100 dark:bg-slate-900-x">
                <div className="max-w-[85rem] px-4 sm:px-6 lg:px-8 mx-auto my-4 sm:my-10">
                    <div className="mx-auto sm:w-11/12 lg:w-3/4">
                        <div className="flex flex-col p-4 bg-white shadow-md sm:p-10 rounded-xl dark:bg-gray-800-x" id="invoiceCard" ref={reportTemplateRef}>
                            <div className="flex justify-between">
                                <div>
                                    <img className="h-20 mx-auto mt-4 ml-0" src="/mti-logo.png" alt="MTINC" />
                                </div>
                                {/* <div>02</div> */}
                                <div>
                                    <h2 className="text-xl font-semibold text-gray-800 md:text-xl dark:text-gray-200-x">Mind Tech Inc.</h2>
                                    <address className="flex block mt-0 text-sm not-italic text-gray-600 dark:text-gray-200-x">
                                        10998, S. WilCrest, Suite-272, <br /> Houston, TX - 77099
                                    </address>
                                    <div className="mt-0">
                                        <p>
                                            <span className="text-sm font-medium text-gray-500">www.mindtechinc.com</span>
                                        </p>
                                        <p>
                                            <span className="text-sm font-medium text-gray-500">accounts@mindtechinc.com</span>
                                        </p>
                                        <p>
                                            <span className="text-sm font-medium text-gray-500">646-790-9628</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-center px-5 my-3 ">
                                <h2 className="text-base font-semibold text-center text-black md:text-xl dark:text-gray-200-">Invoice</h2>
                                {/* <hr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700" /> */}
                            </div>

                            <div className="flex justify-between">
                                <div>
                                    <h2 className="text-sm font-normal text-gray-800 md:text-base dark:text-gray-200-x">Bill To</h2>
                                    {consultant?.vendor && (
                                        <>
                                            <h3 className="pt-0 font-semibold text-gray-800 text-md dark:text-gray-200-x">{consultant?.vendor || consultant?.account}</h3>
                                            <h4 className="text-sm font-normal text-gray-800 dark:text-gray-200-x">{consultant?.address}</h4>
                                        </>
                                    )}
                                </div>
                                <div className="block mt-0 text-gray-500 text-md">
                                    <span className="block">
                                        <b>Invoice No.:</b> {metadata?.invoiceNo || _invNo}
                                    </span>
                                    <span className="block">
                                        {/* format="MMMM DD, YYYY" */}
                                        <b>Invoice Date:</b> {moment.utc(metadata?.invoiceDateLabel).format("MMMM DD, YYYY")}
                                        {/* <Moment filter={toUTCFormat}>
                                            {metadata?.invoiceDate || _d}
                                        </Moment> */}
                                    </span>
                                    <span className="block">
                                        {/* <span>{consultant?.fixed_payroll}</span> */}
                                        {/* <b>Worked Days:</b> {metadata?._punched}/{getWorkingDaysPerMonth(moment(metadata?._d).year())[moment(metadata?._d).month()-1]} days */}
                                    </span>
                                </div>
                            </div>

                            <div className="flex my-3 text-md justify-left">
                                Resource Name: &nbsp; <span className="font-semibold"> {consultant?.name}</span>, &nbsp; <span className="font-normal"> ({consultant?.project})</span>
                                {/* <h2 className="text-base font-semibold text-left text-black md:text-md dark:text-gray-200">Invoice No.</h2> */}
                            </div>

                            {/* {items && items.length > 0 && ( */}
                            <div className="relative pt-0 overflow-x-auto">
                                <table className="w-full text-sm text-left text-gray-500 rtl:text-right dark:text-gray-400-x">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700-x dark:text-gray-400-x">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-left">
                                                Period
                                            </th>
                                            <th scope="col" className="px-6 py-3 text-right">
                                                Billable Hours
                                            </th>
                                            {!consultant?.fixed_payroll && (
                                                <th scope="col" className="px-6 py-3 text-right">
                                                    Rate/ Hr
                                                </th>
                                            )}
                                            <th scope="col" className="px-6 py-3 text-right">
                                                Total $
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!items && (
                                            <tr>
                                                <td colSpan={4}>
                                                    <Skeleton count={2} />
                                                </td>
                                            </tr>
                                        )}

                                        {items &&
                                            items.length > 0 &&
                                            items.map((item) => (
                                                <tr key={nanoid()} className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                                    <td className="px-6 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white-x">
                                                        {(item.first_day_of_week && item.last_day_of_week && (
                                                            <>
                                                                {/* format="MMMM DD" */}
                                                                {/* filter={toUTCFormat1} */}
                                                                <Moment filter={toUTCFormat1}>{item.first_day_of_week}</Moment> {/* format="MMMM DD, YYYY" */}-{/* filter={toUTCFormat} */}
                                                                <Moment filter={toUTCFormat}>{item.last_day_of_week}</Moment>
                                                            </>
                                                        )) ||
                                                            metadata?.title}
                                                    </td>
                                                    <td className="px-6 py-2 text-right">{item._shrs}</td>
                                                    {!consultant?.fixed_payroll && (
                                                        <td className="px-6 py-2 text-right">
                                                            <Currency quantity={item.rate || item.maxrate || metadata.firstNonZeroRate || metadata.maxNonZeroRate || 0} currency="USD" />
                                                        </td>
                                                    )}
                                                    <td className="px-6 py-2 text-right">
                                                        <Currency quantity={Number(item._sbill).toFixed(2) || 0} currency="USD" />
                                                    </td>
                                                </tr>
                                            ))}

                                        {/* Deductions */}
                                        {/* {items && items.length > 0 && (
                                            <tr>
                                                <td className="px-6 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white-x">Deductions ({metadata?.vmo + metadata?.insurance_fee || 0}%) </td>
                                                <td> &nbsp; </td>
                                                <td> &nbsp; </td>
                                                <td>
                                                    {" "}
                                                    <Currency quantity={metadata?._deductions || 0} currency="USD" />{" "}
                                                </td>
                                            </tr>
                                        )} */}

                                        {/* Footer */}
                                        <tr key={nanoid()} className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                            <td className="col-span-2 px-6 py-2 font-medium text-left whitespace-nowrap dark:text-white" colSpan={1}>
                                                <span className="font-semibold text-gray-800 dark:text-gray-200-x">Total </span>
                                            </td>
                                            <td className="col-span-1 px-6 py-2 font-medium text-right whitespace-nowrap dark:text-white-x" colSpan={1}>
                                                {/* <span className="font-semibold text-gray-800 dark:text-gray-200">Total: </span> */}
                                                <span className="font-semibold text-gray-800 dark:text-gray-900">{metadata?._shrs || 0}</span>
                                            </td>
                                            <td className="col-span-1 px-6 py-2 font-medium text-right whitespace-nowrap dark:text-white-x" colSpan={2}>
                                                {/* <span className="font-semibold text-gray-800 dark:text-gray-200">Total: </span> */}
                                                <span className="font-semibold text-gray-800 dark:text-gray-900">
                                                    {consultant?.fixed_payroll > 0 && (
                                                        <>
                                                            <Currency quantity={metadata?._sbill || 0} currency="USD" />
                                                            {/* <Currency quantity={(Number(consultant?.fixed_payroll) / getWorkingDaysPerMonth(moment(metadata?._d).year())[Number(moment(metadata?._d).month() - 1)]) * Number(metadata?._punched)} currency="USD" /> */}
                                                        </>
                                                    )}
                                                    {!consultant?.fixed_payroll && (
                                                        <>
                                                            <Currency quantity={metadata?._sbill || 0} currency="USD" />
                                                        </>
                                                    )}
                                                </span>{" "}
                                            </td>
                                        </tr>

                                        {/* {metadata?._spayment > 0 && (
                                            <tr key={nanoid()} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                                <td className="col-span-4 px-6 py-2 font-medium text-right whitespace-nowrap dark:text-white" colSpan={4}>
                                                    <span className="font-semibold text-gray-800 dark:text-gray-200">Amount paid: </span>
                                                    <Currency quantity={metadata?._spayment || 0} currency="USD" />
                                                </td>
                                            </tr>
                                        )}

                                        {metadata?._spayment > 0 && (
                                            <tr key={nanoid()} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                                <td className="col-span-4 px-6 py-2 font-medium text-right whitespace-nowrap dark:text-white" colSpan={4}>
                                                    <span className="font-semibold text-gray-800 dark:text-gray-200">Due Balance: </span>
                                                    <Currency quantity={metadata?._sbill - metadata?._spayment || 0} currency="USD" />
                                                </td>
                                            </tr>
                                        )} */}
                                    </tbody>
                                </table>
                            </div>

                            {/* )} */}
                            {/* {!items && <Skeleton count={3} />} */}
                            {items && items.length > 0 && false && (
                                <div className="flex mt-5 sm:justify-end">
                                    <div className="w-full max-w-xs space-y-2 sm:text-end">
                                        <div className="grid grid-cols-2 gap-3 sm:grid-cols-1 sm:gap-2">
                                            {/* <dl className="grid sm:grid-cols-5 gap-x-3">
                                            <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Subtotal:</dt>
                                            <dd className="col-span-2 text-gray-500">$2750.00</dd>
                                        </dl> */}

                                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200-x">Total:</dt>
                                                <dd className="col-span-2 text-gray-500">
                                                    <span className="font-semibold text-gray-800 dark:text-gray-200">
                                                        <Currency quantity={metadata?._sbill || 0} currency="USD" />
                                                    </span>{" "}
                                                </dd>
                                            </dl>

                                            {/* <dl className="grid sm:grid-cols-5 gap-x-3">
                                            <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Tax:</dt>
                                            <dd className="col-span-2 text-gray-500">$39.00</dd>
                                        </dl> */}

                                            {/* {metadata?._spayment > 0 && (
                                                <dl className="grid px-6 py-2 text-right sm:grid-cols-5 gap-x-3">
                                                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Amount paid:</dt>
                                                    <dd className="col-span-2 text-gray-500">
                                                        <Currency quantity={metadata?._spayment || 0} currency="USD" />
                                                    </dd>
                                                </dl>
                                            )}

                                            {metadata?._spayment > 0 && (
                                                <dl className="grid sm:grid-cols-5 gap-x-3">
                                                    <dt className="col-span-3 font-semibold text-gray-800 dark:text-gray-200">Due Balance:</dt>
                                                    <dd className="col-span-2 text-gray-500">
                                                        <Currency quantity={metadata?._sbill - metadata?._spayment || 0} currency="USD" />
                                                    </dd>
                                                </dl>
                                            )} */}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="flex gap-2 pt-2 overflow-x-auto place-content-right">
                                <table className="text-sm text-left text-gray-500 w-2xl rtl:text-right dark:text-gray-400-x">
                                    <tbody>
                                        <tr className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                            <td className="px-6 py-2 text-right">Remit Payment To</td>
                                            <td className="px-6 py-2 text-right">Mind Tech Inc.</td>
                                        </tr>
                                        <tr className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                            <td className="px-6 py-2 text-right">EIN #</td>
                                            <td className="px-6 py-2 text-right">47-1995113</td>
                                        </tr>
                                        <tr className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                            <td className="px-6 py-2 text-right">Phone No.</td>
                                            <td className="px-6 py-2 text-right">646-790-9628</td>
                                        </tr>
                                        <tr className="bg-white border-b dark:bg-gray-800-x dark:border-gray-700-x">
                                            <td className="px-6 py-2 text-right">Email</td>
                                            <td className="px-6 py-2 text-right">accounts@mindtechinc.com</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="mt-5 sm:mt-6">
                                <p className="mb-2 text-md ">
                                    Please make payment of{" "}
                                    <strong>
                                        {/* <Currency quantity={metadata?._sbill - metadata?._spayment || 0} currency="USD" /> */}
                                        <Currency quantity={metadata?._sbill || 0} currency="USD" />{" "}
                                    </strong>
                                    to <b>Mind Tech Inc.</b> at <span className="">10998, S. WilCrest, Suite-272, Houston, TX - 77099</span>
                                </p>
                            </div>

                            <div className="mt-4 sm:mt-5">
                                {/* <h4 className="font-semibold text-gray-800 text-md dark:text-gray-200">Thank you!</h4> */}
                                {/* <p className="text-sm text-gray-500">If you have any questions concerning this invoice, use the following contact information:</p> */}
                                {/* <div className="mt-1">
                                    <span className="text-sm font-medium text-blue-800">support@mindtechinc.com</span> <span className="text-gray-500">|</span> <span className="text-sm font-medium text-blue-800">+1 (281) 369-4409</span>
                                </div> */}
                            </div>
                            {/* <p className="mt-2 text-xs text-gray-400">This invoice is computer-generated and does not require a signature.</p>
                            <p className="mt-3 text-sm text-gray-500">
                                © {new Date().getFullYear()} <b>Mind Tech Inc.</b>
                            </p> */}
                        </div>

                        <div className="flex justify-end mt-6 gap-x-3">
                            <a onClick={() => onGeneratePDF()} className="inline-flex items-center justify-center gap-2 px-3 py-2 text-sm text-gray-700 align-middle transition-all bg-white border rounded-lg shadow-sm font-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 dark:bg-gray-800 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800" href="#">
                                <svg className="flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" x2="12" y1="15" y2="3" />
                                </svg>
                                Download Invoice PDF
                            </a>
                            {/* <a className="inline-flex items-center px-3 py-2 text-sm font-semibold text-white bg-blue-900 border border-transparent rounded-lg gap-x-2 hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#">
                                <svg className="flex-shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="6 9 6 2 18 2 18 9" />
                                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                                    <rect width="12" height="8" x="6" y="14" />
                                </svg>
                                Print
                            </a> */}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
function setElementOutlet(current: string) {
    throw new Error("Function not implemented.");
}
